import React from "react";
import DfiBotDashboard from "./DfiBotDashboard";

// VEDA theme — Emerald / Teal on deep forest-midnight (defensive yield, evergreen)
const VEDA_THEME = {
    name: "emerald",
    bg: "#031612",
    hex: "#10b981",
    hexHi: "#34d399",
    text: "text-emerald-300",
    textSoft: "text-emerald-400",
    textSoft2: "text-emerald-300/80",
    textSoft3: "text-emerald-300/70",
    border: "border-emerald-400/30",
    borderSoft: "border-emerald-400/40",
    borderDim: "border-emerald-400/20",
    bgGlow: "bg-emerald-400/5",
    divide: "divide-emerald-400/10",
    glow: "drop-shadow-[0_0_30px_rgba(16,185,129,0.5)]",
    bar: "bg-emerald-400",
    hairline: "bg-emerald-400/40",
    gridLine: "rgba(16,185,129,0.1)",
    accentDot: "bg-emerald-400",
};

const veda = {
    name: "VEDA",
    tagline: "Delta-Neutral Yield · The See's Candies of DFI.",
    subTitle: "Four uncorrelated streams · 1.8× book leverage · $100K institutional baseline",
    status: "LIVE · YIELD ENGINE",
    statusTone: "text-emerald-300 border-emerald-400/40 bg-emerald-400/5",
    theme: VEDA_THEME,
    baseCapital: 100000,
    annualApy: "33.05%",
    monthlyApy: "2.41%",
    periodReturn: 0.0721, // 90-day at 33.05% CAGR (pre-insurance)
    kpis: [
        { value: "33.05%", label: "CAGR · Pre-Insurance", sub: "16Q backtest · fee-adjusted" },
        { value: "5.15",   label: "Sharpe Ratio",         sub: "institutional levered" },
        { value: "0.00%",  label: "Max Drawdown",         sub: "across all 16 quarters" },
        { value: "2-3%",   label: "Insurance Carve-Out",  sub: "Nexus / Sherlock / InsurAce" },
        { value: "100%",   label: "Quarterly Win-Rate",   sub: "every single quarter positive" },
    ],
    streams: [
        {
            title: "Stream 1 · Stable Earn",
            rate: "~4.5% APR",
            alloc: "10% of NAV · $10,000",
            detail:
                "USDC Flexible Savings on Bybit Earn + Aave-v3 supply on Arbitrum. Floor yield that never sleeps.",
        },
        {
            title: "Stream 2 · Levered stETH",
            rate: "~7.5% net APR",
            alloc: "20% of NAV · $20,000",
            detail:
                "stETH yield with 3× internal loop via Aave borrow against stETH collateral. Insured by Sherlock / Chainproof.",
        },
        {
            title: "Stream 3 · Funding Arbitrage",
            rate: "~28% APR",
            alloc: "55% of NAV · $55,000",
            detail:
                "Spot-long + perp-short pairs across BTC / ETH / SOL on Bybit. Book leverage 1.8×. The engine.",
        },
        {
            title: "Stream 4 · Covered Calls",
            rate: "~9% APR",
            alloc: "15% of NAV · $15,000",
            detail:
                "30-day 0.25-delta ETH call-writing on Bybit Options. Premium capture with capped upside.",
        },
    ],
    notes: [
        "Headline 33.05% CAGR is PRE-INSURANCE · 2-3% APR carve-out for Nexus + Sherlock + InsurAce applied separately. Net to allocator = ~30.05%-31.05%.",
        "Live NAV currently tracking +7.21% in 90 days = 33.05% annualized · dead-on backtest CAGR · zero deviation.",
        "4,360 60-second snapshots · 830 trades executed · zero kill-switch fires lifetime.",
        "Insurance stack live above $1M AUM: Nexus Mutual (exchange) + Sherlock (smart contract) + InsurAce (depeg) + 2% USDC sidecar.",
        "Kill switch: any single-tick portfolio delta > 3% auto-halts the engine. Operator reconciles manually before resume.",
    ],
};

export default function DfiVeda() {
    return <DfiBotDashboard bot={veda} />;
}
